module.exports = __webpack_public_path__ + "img/nk.3017ec3c.png";